module.exports = __webpack_public_path__ + "img/login.60d5b19d.png";